import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export const ClearYmmeMake: Handler = ({ dispatch }) => {
    const untypedDispatch: any = dispatch;
    untypedDispatch({
        type: "Custom/Ymme/MakeSelected",
        parameter: "",
    });
};

export const ClearYmmeModel: Handler = ({ dispatch }) => {
    const untypedDispatch: any = dispatch;
    untypedDispatch({
        type: "Custom/Ymme/ModelSelected",
        parameter: "",
    });
};

export const ClearYmmeYear: Handler = ({ dispatch }) => {
    const untypedDispatch: any = dispatch;
    untypedDispatch({
        type: "Custom/Ymme/YearSelected",
        parameter: "",
    });
};

export const ClearYmmeEngine: Handler = ({ dispatch }) => {
    const untypedDispatch: any = dispatch;
    untypedDispatch({
        type: "Custom/Ymme/EngineSelected",
        parameter: "",
    });
};

export const chain = [ClearYmmeMake, ClearYmmeModel, ClearYmmeYear, ClearYmmeEngine];

const clearYmmeState = createHandlerChainRunner(chain, "ClearYmmeState");
export default clearYmmeState;
